
export const CONST_DEBUG = import.meta.env.DEV;

//if REACT_APP_SERVER_URL has .prod. in it, we are in prod mode
export const kDebugMode = CONST_DEBUG || !(import.meta.env.REACT_APP_SERVER_URL?.includes(".prod.") ?? false);
export const kProdMode = !kDebugMode;

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export const randomId = () => Math.random().toString(36)
